const fuelsWithWhiteText = ['BD', 'CNG', 'LNG'];

export default function stationPinColor(fuel) {
  let pinClass = 'afdc-letter';
  if (fuelsWithWhiteText.includes(fuel)) {
    pinClass += ' afdc-white';
  }

  return pinClass;
}
